<gcc-header></gcc-header>
<div
  class="container-fluid content"
  (scroll)="onScrolls()"
  [ngStyle]="{ paddingTop: (isShowNotifications ? notificationsAndHeaderHeight : defaultHeaderHeight) + 'px' }"
>
  <router-outlet></router-outlet>
</div>

<gcc-toastr></gcc-toastr>
<gcc-loader></gcc-loader>
